<template>
	<div class="mianPage">
		<div class="topSearch">
			<el-form inline class="el-form flex_start">
				<el-form-item>
					<el-input v-model="queryData.source" clearable size="small" placeholder="请输入预算种类"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="queryData.appName" clearable size="small" placeholder="请输入APP名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model="queryData.appPkg" clearable size="small" placeholder="请输入APP包名"></el-input>
				</el-form-item>
				<div class="menu-right">
					<el-button size="small" @click="searchReset">重置</el-button>
					<el-button type="primary" size="small" @click="confirmQuery">查询</el-button>
				</div>
			</el-form>
		</div>

		<div class="tableBox">
			<div class="tableTopBtn space_between">
				<el-button type="primary" size="small" @click="addTableData">
					<i class="el-icon-plus"></i> 新增
				</el-button>
				<!-- <el-upload
					class="upload-demo"
					action="#"
					accept=".xls,.xlsx,.csv"
					:show-file-list="false"
					:before-upload="beforeImportUpload"
					:http-request="uploadFile"
				>
					<el-button type="primary" plain icon="el-icon-upload2" size="small">导入</el-button>
				</el-upload> -->
			</div>
			<el-table
				:data="tableData"
				:max-height="560"
				:header-cell-style="{color:'#333333',background:'#EAEFF5'}"
				class="el_table"
			>
				<el-table-column prop="source" label="预算种类" min-width="130"></el-table-column>
				<el-table-column label="APP名称" min-width="210">
					<template slot-scope="scope">
						<div class="list-cell">{{ formatStringList(scope.row.appNameList) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="APP包名" min-width="210">
					<template slot-scope="scope">
						<div class="list-cell">{{ formatStringList(scope.row.appPkgList) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="DP" min-width="210">
					<template slot-scope="scope">
						<div class="list-cell">{{ formatStringList(scope.row.dpPrefixList) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="storeId" min-width="190">
					<template slot-scope="scope">
						<div class="list-cell">{{ formatStringList(scope.row.storeIdList) }}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" fixed="right" width="120">
					<template slot-scope="scope">
						<el-button type="text" @click="editTable(scope.row)">编辑</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="paging">
				<el-pagination
					background
					:current-page="currentPage"
					:page-sizes="[10, 20, 30, 50]"
					:page-size="pageSize"
					:total="total"
					layout="total, sizes, prev, pager, next, jumper"
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
				>
				</el-pagination>
			</div>
		</div>

		<el-dialog
			:title="isEdit ? '编辑预算映射' : '新增预算映射'"
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			width="560px"
			@closed="resetDialog"
		>
			<el-form
				ref="budgetMapForm"
				:model="formData"
				:rules="formRules"
				label-width="170px"
				class="budget-map-form"
			>
				<el-form-item label="预算种类：" prop="source">
					<el-input v-model="formData.source" clearable size="small" placeholder="请输入预算种类"></el-input>
				</el-form-item>
				<el-form-item v-for="item in tagFieldOptions" :key="item.field" :label="item.label + '：'">
					<div class="tag-editor">
						<div v-if="formData[item.field].length" class="tag-list">
							<template v-for="(tag, index) in formData[item.field]">
								<el-input
									v-if="editTag.field === item.field && editTag.index === index"
									:key="item.field + '-edit-' + index"
									:ref="'editTagInput-' + item.field"
									v-model="editTag.value"
									class="tag-input tag-edit-input"
									size="small"
									maxlength="200"
									@keyup.enter.native="confirmTagEdit"
									@keyup.esc.native="cancelTagEdit"
									@blur="confirmTagEdit"
								></el-input>
								<el-tag
									v-else
									:key="item.field + '-tag-' + index"
									closable
									disable-transitions
									@close="removeTag(item.field, index)"
								>
									<span>{{ tag }}</span>
									<i class="el-icon-edit tag-edit-icon" @click.stop="startTagEdit(item.field, index)"></i>
								</el-tag>
							</template>
						</div>
						<el-input
							v-if="tagInputVisible[item.field]"
							:ref="'tagInput-' + item.field"
							v-model="tagInputs[item.field]"
							class="tag-input"
							size="small"
							maxlength="200"
							:placeholder="item.placeholder"
							@keyup.enter.native="confirmTagInput(item.field)"
							@blur="confirmTagInput(item.field)"
						></el-input>
						<el-button v-else class="add-tag-button" size="small" @click="showTagInput(item.field)">
							<i class="el-icon-plus"></i> 添加
						</el-button>
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="medium" @click="dialogVisible = false">取消</el-button>
				<el-button type="primary" size="medium" @click="submitForm">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				queryData: {
					source: '', // 预算种类筛选值
					appName: '', // APP名称筛选值
					appPkg: '', // APP包名筛选值
				},
				tableData: [], // 预算映射表格数据
				currentPage: 1, // 当前页码
				pageSize: 10, // 每页数据条数
				total: 0, // 表格数据总数
				dialogVisible: false, // 新增、编辑弹框显隐状态
				isEdit: false, // 是否为编辑状态
				formData: this.createEmptyForm(), // 新增、编辑表单数据
				formRules: {
					source: [{required: true, message: '请输入预算种类', trigger: 'blur'}], // 预算种类必填规则
				},
				tagFieldOptions: [
					{field: 'appNameList', label: 'APP名称', placeholder: '请输入APP名称'},
					{field: 'appPkgList', label: 'APP包名', placeholder: '请输入APP包名'},
					{field: 'dpPrefixList', label: 'DP', placeholder: '请输入DP'},
					{field: 'storeIdList', label: 'iOS ID/Android ID', placeholder: '请输入storeId'},
				], // 可维护多个字符串的字段配置
				tagInputs: {
					appNameList: '',
					appPkgList: '',
					dpPrefixList: '',
					storeIdList: '',
				}, // 各字符串数组字段的新增输入值
				tagInputVisible: {
					appNameList: false,
					appPkgList: false,
					dpPrefixList: false,
					storeIdList: false,
				}, // 各字符串数组字段的新增输入框显隐状态
				editTag: {
					field: '',
					index: -1,
					value: '',
				}, // 当前正在编辑的标签信息
			}
		},
		mounted() {
			this.getTableData();
		},
		methods: {
			// 创建空白表单，确保四个非必填字段始终以数组提交
			createEmptyForm() {
				return {
					source: '',
					appNameList: [],
					appPkgList: [],
					dpPrefixList: [],
					storeIdList: [],
				}
			},
			// 获取预算映射分页列表
			async getTableData() {
				let data = {
					pageNum: this.currentPage,
					pageSize: this.pageSize,
					...this.queryData,
				}
				let res = await this.$http.post(this.$api.operationalAnalysis.budgetMapList, data);
				if (res && res.code == 1) {
					let pageData = res.data || {};
					this.tableData = pageData.list || pageData.records || [];
					this.total = pageData.totalRecord || pageData.total || 0;
				}
			},
			// 将字符串数组格式化为表格展示文本
			formatStringList(value) {
				if (Array.isArray(value)) {
					return value.length ? value.join('、') : '-';
				}
				return value || '-';
			},
			// 切换分页条数并查询第一页
			handleSizeChange(val) {
				this.currentPage = 1;
				this.pageSize = val;
				this.getTableData();
			},
			// 切换当前页并刷新列表
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getTableData();
			},
			// 重置顶部筛选条件
			searchReset() {
				this.currentPage = 1;
				this.queryData = {source: '', appName: '', appPkg: ''};
				this.getTableData();
			},
			// 根据顶部筛选条件查询列表
			confirmQuery() {
				this.currentPage = 1;
				this.getTableData();
			},
			// 打开新增预算映射弹框
			addTableData() {
				this.isEdit = false;
				this.formData = this.createEmptyForm();
				this.dialogVisible = true;
			},
			// 打开编辑弹框，并复制表格数据
			editTable(row) {
				this.isEdit = true;
				this.formData = {
					id: row.id,
					source: row.source || '',
					appNameList: this.normalizeStringList(row.appNameList),
					appPkgList: this.normalizeStringList(row.appPkgList),
					dpPrefixList: this.normalizeStringList(row.dpPrefixList),
					storeIdList: this.normalizeStringList(row.storeIdList),
				};
				this.dialogVisible = true;
			},
			// 兼容接口返回单个字符串并复制数组
			normalizeStringList(value) {
				if (Array.isArray(value)) {
					return value.slice();
				}
				return value ? [value] : [];
			},
			// 展示指定字段的标签新增输入框
			showTagInput(field) {
				this.cancelTagEdit();
				this.tagInputVisible[field] = true;
				this.focusInput('tagInput-' + field);
			},
			// 将输入内容添加到指定字符串数组
			confirmTagInput(field) {
				let value = this.tagInputs[field].trim();
				if (value && this.formData[field].includes(value)) {
					this.$message.warning('请勿添加重复内容');
					return
				}
				if (value) {
					this.formData[field].push(value);
				}
				this.tagInputs[field] = '';
				this.tagInputVisible[field] = false;
			},
			// 删除指定数组中的标签
			removeTag(field, index) {
				this.formData[field].splice(index, 1);
				if (this.editTag.field === field) {
					this.cancelTagEdit();
				}
			},
			// 将指定标签切换为编辑输入框
			startTagEdit(field, index) {
				this.editTag = {field, index, value: this.formData[field][index]};
				this.focusInput('editTagInput-' + field);
			},
			// 保存当前标签编辑内容
			confirmTagEdit() {
				let {field, index} = this.editTag;
				if (!field || index < 0) {
					return
				}
				let value = this.editTag.value.trim();
				let isDuplicate = this.formData[field].some((item, itemIndex) => item === value && itemIndex !== index);
				if (value && isDuplicate) {
					this.$message.warning('请勿添加重复内容');
					return
				}
				if (value) {
					this.$set(this.formData[field], index, value);
				} else {
					this.formData[field].splice(index, 1);
				}
				this.cancelTagEdit();
			},
			// 取消当前标签编辑状态
			cancelTagEdit() {
				this.editTag = {field: '', index: -1, value: ''};
			},
			// 聚焦动态创建的标签输入框
			focusInput(refName) {
				this.$nextTick(() => {
					let inputRef = this.$refs[refName];
					let input = Array.isArray(inputRef) ? inputRef[0] : inputRef;
					if (input) {
						input.focus();
					}
				});
			},
			// 校验并提交新增或编辑表单
			submitForm() {
				this.$refs.budgetMapForm.validate(async (valid) => {
					if (!valid) {
						return
					}
					let data = JSON.parse(JSON.stringify(this.formData));
					let requestUrl = this.isEdit
						? this.$api.operationalAnalysis.budgetMapUpdate
						: this.$api.operationalAnalysis.budgetMapAdd;
					let res = await this.$http.post(requestUrl, data);
					if (res && res.code == 1) {
						this.$message.success(this.isEdit ? '编辑成功' : '新增成功');
						this.dialogVisible = false;
						this.getTableData();
					}
				});
			},
			// 弹框关闭后清理校验与标签输入状态
			resetDialog() {
				this.formData = this.createEmptyForm();
				Object.keys(this.tagInputs).forEach((field) => {
					this.tagInputs[field] = '';
					this.tagInputVisible[field] = false;
				});
				this.cancelTagEdit();
				if (this.$refs.budgetMapForm) {
					this.$refs.budgetMapForm.clearValidate();
				}
			},
			// 校验导入文件格式
			beforeImportUpload(file) {
				let extension = file.name.split('.').pop().toLowerCase();
				let isExcel = ['xls', 'xlsx', 'csv'].includes(extension);
				if (!isExcel) {
					this.$message.warning('仅支持导入xls、xlsx或csv文件');
				}
				return isExcel
			},
			// 导入接口暂未开放，保留入口并提示当前状态
			uploadFile() {
				this.$message.warning('导入接口暂未开放');
			},
		},
	}
</script>

<style scoped>
	.mianPage {
		padding: 10px;
	}

	.topSearch {
		background: #FFFFFF;
		border-radius: 4px;
		padding: 16px 16px 6px;
	}

	.el-form {
		flex-wrap: wrap;
	}

	/deep/ .el-form--inline .el-form-item {
		margin-right: 20px !important;
	}

	/deep/ .topSearch .el-form-item {
		margin-bottom: 10px;
	}

	.menu-right {
		margin-left: auto;
		margin-top: 4px;
	}

	.tableBox {
		margin-top: 10px;
		background: #FFFFFF;
		border-radius: 4px;
		padding: 16px;
	}

	.tableTopBtn {
		align-items: center;
		margin-bottom: 16px;
	}

	.upload-demo /deep/ .el-upload {
		display: block;
	}

	.list-cell {
		line-height: 20px;
		word-break: break-all;
	}

	.paging {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.budget-map-form {
		padding-right: 20px;
	}

	.budget-map-form /deep/ .el-form-item__content {
		line-height: 32px;
	}

	.budget-map-form /deep/ .el-input {
		width: 100%;
	}

	.tag-editor {
		width: 100%;
		min-height: 32px;
	}

	.tag-list {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		margin-bottom: 8px;
	}

	.tag-list /deep/ .el-tag {
		max-width: 100%;
		height: auto;
		min-height: 28px;
		line-height: 26px;
		white-space: normal;
		word-break: break-all;
	}

	.tag-edit-icon {
		margin-left: 6px;
		cursor: pointer;
	}

	.tag-input {
		width: 100%;
	}

	.tag-edit-input {
		width: 220px;
	}

	.add-tag-button {
		border-style: dashed;
	}

	.dialog-footer {
		text-align: right;
	}
</style>
